import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Box, Stack } from '@mui/material';
import SBDebitNoteTable from '../components/SBDebitNoteTable';
import useDocumentFilters from '../../../components/filters/DocumentFilterHelper';
import DocumentListFilters from '../../../components/filters/DocumentListFilters';

const filters = [
  {
    type: 'search',
    options: [
      { key: 'document_number', placeholder: 'Debit Note Number' },
      { key: 'invoice_number', placeholder: 'Invoice Number' },
      { key: 'billed_by_name', placeholder: 'Buyer Name' },
      { key: 'billed_to_name', placeholder: 'Supplier Name' },
      { key: 'billed_to_phone', placeholder: 'Supplier Phone' },
      { key: 'billed_to_tin', placeholder: 'Supplier TIN' },
      { key: 'billed_to_registration_number', placeholder: 'Supplier Registration Number' },
    ],
  },
];

function SBDebitNoteListPage() {
  useDocumentTitle('Self Billed Debit Note List');

  const {
    selectedFilter,
    searchTerm,
    currentQuery,
    includeResubmitted,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleStatusChange,
    handleDateRangeChange,
    handleIncludeResubmittedChange,
    handlePaginationChange,
  } = useDocumentFilters({
    defaultQuery: { document_type: 13, status: new Set(['active']) },
  });

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box mb={2}>
        <DocumentListFilters
          filters={filters}
          selectedFilter={selectedFilter}
          onFilterChange={handleFilterChange}
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchKeyPress={handleSearchKeyPress}
          onStatusChange={handleStatusChange}
          onDateRangeChange={handleDateRangeChange}
          includeResubmitted={includeResubmitted}
          onIncludeResubmittedChange={handleIncludeResubmittedChange}
        />
      </Box>
      <SBDebitNoteTable handlePaginationChange={handlePaginationChange} searchQuery={currentQuery} />
    </Stack>
  );
}

export default SBDebitNoteListPage;
